import assocPath from "ramda/es/assocPath";
import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import equals from "ramda/es/equals";
import map from "ramda/es/map";
import split from "ramda/es/split";
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path.
 *
 * @documented
 * @category Object
 * @param {String} path the dot path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @example
 *
 *      setInPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      setInPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ const setInPath = curry((pathToData, value, obj)=>assocPath(compose(map((val)=>{
        const arrIdx = parseInt(val);
        return equals(NaN, arrIdx) ? val : arrIdx;
    }), split('.'))(pathToData), value, obj));
export default setInPath;
